<template>
  <div id="RefundMgmt" class="purchase-mgmt-page">
    <div class="page-header">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">供应商</span>
            <el-select v-model="params.supplierId" size="small" filterable clearable placeholder="全部">
              <el-option v-for="supplier in supplierList" :key="supplier.supplierId" :label="supplier.supplierShortName" :value="supplier.supplierId"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">退款单号</span>
            <el-input v-model="params.refundGroupId" size="small" clearable placeholder="请输入退款单号"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品名称</span>
            <el-input v-model="params.productName" size="small" clearable placeholder="请输入产品名称"></el-input>
          </div>
          <div class="filter-item">
            <el-button type="primary" size="small" icon="el-icon-search" @click="queryBtn">查询</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <el-tabs v-model="activeStatusTab" class="status-tabs" @tab-click="onStatusTabChange">
        <el-tab-pane v-for="tab in statusTabs" :key="tab.name" :name="tab.name">
          <span slot="label" class="status-tab-label">
            {{ tab.label }}
            <el-badge v-if="tab.showBadge && statusCounts[tab.name] > 0" :value="statusCounts[tab.name]" class="status-tab-badge"></el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>

      <div class="table-container">
        <el-table ref="refundTable" :data="tableData" border stripe size="mini" :height="screenHeight" v-loading="loading" element-loading-text="加载中..." :span-method="spanMethod" header-cell-class-name="table-header-cell" class="mgmt-table refund-table">
          <el-table-column label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              <span v-if="scope.row._refundRowSpan > 0">{{ getGroupRowIndex(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refundGroupId" label="退款单号" width="150" align="center" fixed="left" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shopName" label="店铺" width="70" align="center" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierShortName" label="供应商" width="100" class-name="merge-col" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.supplierShortName || scope.row.supplierName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="refundQuantity" label="退款数量" width="80" align="right"></el-table-column>
          <el-table-column prop="unitPrice" label="退款单价" width="90" align="right">
            <template slot-scope="scope">{{ formatRefundAmount(scope.row.unitPrice) }}</template>
          </el-table-column>
          <el-table-column prop="expectedRefundAmount" label="应退金额" width="100" align="right">
            <template slot-scope="scope">{{ formatRefundAmount(scope.row.expectedRefundAmount) }}</template>
          </el-table-column>
          <el-table-column prop="actualRefundAmount" label="实退金额" width="100" align="right">
            <template slot-scope="scope">{{ formatRefundAmount(scope.row.actualRefundAmount) }}</template>
          </el-table-column>
          <el-table-column prop="refundDiff" label="差额" width="90" align="right">
            <template slot-scope="scope">
              <span :class="getRefundDiffClass(scope.row.refundDiff)">{{ formatRefundDiff(scope.row.refundDiff) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalExpectedRefundAmount" label="总应退金额" width="100" align="right" class-name="merge-col">
            <template slot-scope="scope">{{ formatRefundAmount(scope.row.totalExpectedRefundAmount) }}</template>
          </el-table-column>
          <el-table-column prop="totalActualRefundAmount" label="总实退金额" width="100" align="right" class-name="merge-col">
            <template slot-scope="scope">{{ formatRefundAmount(scope.row.totalActualRefundAmount) }}</template>
          </el-table-column>
          <el-table-column prop="totalRefundDiff" label="总差额" width="90" align="right" class-name="merge-col">
            <template slot-scope="scope">
              <span :class="getRefundDiffClass(scope.row.totalRefundDiff)">{{ formatRefundDiff(scope.row.totalRefundDiff) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="采购退款证明" width="140" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="getProofImageList(scope.row, 'purchaseRefundProof').length" class="proof-thumb-list">
                <el-image v-for="(url, index) in getProofImageList(scope.row, 'purchaseRefundProof')" :key="url + '-' + index" :src="url" :preview-src-list="getProofImageList(scope.row, 'purchaseRefundProof')" fit="cover" class="proof-thumb"></el-image>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column label="财务到账证明" width="140" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="getProofImageList(scope.row, 'financeArrivalProof').length" class="proof-thumb-list">
                <el-image v-for="(url, index) in getProofImageList(scope.row, 'financeArrivalProof')" :key="url + '-' + index" :src="url" :preview-src-list="getProofImageList(scope.row, 'financeArrivalProof')" fit="cover" class="proof-thumb"></el-image>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="300" class-name="merge-col" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{ scope.row.remark || "-" }}</div>
              <div v-if="scope.row.rejectRemark" class="reject-remark">打回：{{ scope.row.rejectRemark }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="退款状态" width="120" align="center" class-name="merge-col"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="150" align="center" class-name="merge-col">
            <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="320" align="center" class-name="merge-col action-col">
            <template slot-scope="scope">
              <div v-if="scope.row._refundRowSpan > 0" class="action-cell action-cell-nowrap">
                <el-button v-if="scope.row.status === '待确认退款信息'" type="text" size="small" @click="confirmRefundInfo(scope.row)">确认退款信息</el-button>
                <el-button v-if="scope.row.status === '待退款'" type="text" size="small" class="success" @click="openPurchaseConfirm(scope.row)">确认已退款</el-button>
                <el-button v-if="scope.row.status === '待财务审核'" type="text" size="small" @click="openFinanceConfirm(scope.row)">确认已退款</el-button>
                <el-button v-if="scope.row.status === '待财务审核'" type="text" size="small" class="warning" @click="openRejectDialog(scope.row)">打回</el-button>
                <el-button v-if="scope.row.status === '待确认退款信息' || scope.row.status === '待退款'" type="text" size="small" class="danger" @click="voidRefund(scope.row)">作废</el-button>
                <el-button type="text" size="small" @click="openRefundDetails(scope.row)">退款明细</el-button>
                <el-button type="text" size="small" @click="showOpreateLog(scope.row)">操作记录</el-button>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="" min-width="0" class-name="merge-col"> </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination layout="prev, pager, next" background prev-text="上一页" next-text="下一页" :current-page.sync="currentPage" :page-size="params.pageSize" :total="total" @current-change="onPageChange"></el-pagination>
      </div>
    </div>

    <el-dialog title="确认已退款" :visible.sync="purchaseConfirmVisible" width="680px" custom-class="refund-proof-dialog" :close-on-click-modal="false" @opened="onPurchaseConfirmDialogOpened" @closed="onPurchaseConfirmDialogClosed">
      <div class="finance-confirm-tip">请上传采购已退款证明；可先「保存」证明，确认后进入「待财务审核」。</div>
      <div ref="purchasePastePanel" class="proof-upload-panel" tabindex="0" v-loading="proofUploading">
        <div class="proof-upload-list">
          <div v-for="(url, index) in purchaseProofUrls" :key="url + '-' + index" class="proof-upload-item">
            <el-image :src="url" fit="cover" class="proof-upload-image"></el-image>
            <i class="el-icon-error proof-upload-remove" @click="purchaseProofUrls.splice(index, 1)"></i>
          </div>
          <el-upload class="proof-upload-add" action="/biz/oss/upload" name="file" accept="image/*" :data="{ bizModule: 'refund' }" :show-file-list="false" :before-upload="beforeProofImageUpload" :on-success="handlePurchaseProofUploadSuccess" :disabled="proofUploading">
            <div class="proof-upload-trigger">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <span class="proof-upload-text">添加图片</span>
            </div>
          </el-upload>
        </div>
        <div class="proof-upload-tip">支持 JPG、PNG、GIF、WEBP、BMP；可上传多张，可在本弹窗内 Ctrl+V 粘贴截图</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="purchaseConfirmVisible = false">取 消</el-button>
        <el-button @click="savePurchaseProof" :loading="purchaseConfirmSaving">保 存</el-button>
        <el-button type="primary" @click="confirmPurchaseRefunded" :loading="purchaseConfirmSaving">确认已退款</el-button>
      </div>
    </el-dialog>

    <el-dialog title="财务确认已退款" :visible.sync="financeConfirmVisible" width="680px" :close-on-click-modal="false" @opened="onFinanceProofDialogOpened" @closed="onFinanceProofDialogClosed">
      <div class="finance-confirm-tip">请上传财务到账证明后确认已到账；也可先「保存」证明，或关闭后点击「打回」并填写原因。</div>
      <div ref="financePastePanel" class="proof-upload-panel" tabindex="0" v-loading="proofUploading">
        <div class="proof-upload-list">
          <div v-for="(url, index) in financeProofUrls" :key="url + '-' + index" class="proof-upload-item">
            <el-image :src="url" fit="cover" class="proof-upload-image"></el-image>
            <i class="el-icon-error proof-upload-remove" @click="financeProofUrls.splice(index, 1)"></i>
          </div>
          <el-upload class="proof-upload-add" action="/biz/oss/upload" name="file" accept="image/*" :data="{ bizModule: 'refund' }" :show-file-list="false" :before-upload="beforeProofImageUpload" :on-success="handleFinanceProofUploadSuccess" :disabled="proofUploading">
            <div class="proof-upload-trigger">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <span class="proof-upload-text">添加图片</span>
            </div>
          </el-upload>
        </div>
        <div class="proof-upload-tip">支持多张图片，可在本弹窗内 Ctrl+V 粘贴截图</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="financeConfirmVisible = false">取 消</el-button>
        <el-button @click="saveFinanceProof" :loading="financeConfirmSaving">保 存</el-button>
        <el-button type="primary" @click="confirmFinanceRefunded" :loading="financeConfirmSaving">确认已到账</el-button>
      </div>
    </el-dialog>

    <el-dialog title="打回退款单" :visible.sync="rejectVisible" width="480px" :close-on-click-modal="false">
      <el-form label-width="80px">
        <el-form-item label="打回原因" required>
          <el-input v-model="rejectRemark" type="textarea" :rows="4" placeholder="请填写打回原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmReject" :loading="rejectSaving">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="退款明细" :visible.sync="refundDetailsVisible" width="1280px">
      <el-table :data="refundDetails" border stripe size="mini" max-height="420" v-loading="refundDetailsLoading" show-summary :summary-method="getRefundDetailSummaries">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="date" label="采购日期" width="100" align="center"></el-table-column>
        <el-table-column prop="shopName" label="店铺" width="70" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sku" label="SKU" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseColorName" label="颜色" width="80" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.purchaseColorName || scope.row.productColorName || "-" }}</template>
        </el-table-column>
        <el-table-column prop="model" label="机型" width="90" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planPurchase" label="采购数量" width="80" align="right">
          <template slot-scope="scope">{{ scope.row.planPurchase != null ? scope.row.planPurchase : "-" }}</template>
        </el-table-column>
        <el-table-column prop="refundQuantity" label="退款数量" width="80" align="right"></el-table-column>
        <el-table-column prop="unitPrice" label="退款单价" width="90" align="right">
          <template slot-scope="scope">{{ formatRefundAmount(scope.row.unitPrice) }}</template>
        </el-table-column>
        <el-table-column prop="refundAmount" label="退款金额" width="90" align="right">
          <template slot-scope="scope">{{ formatRefundAmount(scope.row.refundAmount) }}</template>
        </el-table-column>
        <el-table-column prop="expectedRefundAmount" label="应退金额" width="90" align="right">
          <template slot-scope="scope">{{ formatRefundAmount(scope.row.expectedRefundAmount) }}</template>
        </el-table-column>
        <el-table-column prop="actualRefundAmount" label="实退金额" width="90" align="right">
          <template slot-scope="scope">{{ formatRefundAmount(scope.row.actualRefundAmount) }}</template>
        </el-table-column>
        <el-table-column prop="refundDiff" label="差额" width="90" align="right">
          <template slot-scope="scope">
            <span :class="getRefundDiffClass(scope.row.refundDiff)">{{ formatRefundDiff(scope.row.refundDiff) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="采购单号" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.orderNo || scope.row.purchaseId || "-" }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refundDetailsVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="960px">
      <el-table :data="operateHistory" border stripe size="mini" max-height="420" v-loading="opreateLogLoading">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="90"></el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="140"></el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="操作详情" min-width="240" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { refundModules, requestModules, ossModules } from "@r";

const STATUS_TABS = [
  { name: "待确认退款信息", label: "待确认退款信息", showBadge: true },
  { name: "待退款", label: "待退款", showBadge: true },
  { name: "待财务审核", label: "待财务审核", showBadge: true },
  { name: "已退款", label: "已退款", showBadge: false },
  { name: "已作废", label: "已作废", showBadge: true },
  { name: "全部", label: "全部", showBadge: false },
];

const MERGE_PROPS = [
  "refundGroupId",
  "shopName",
  "supplierShortName",
  "totalExpectedRefundAmount",
  "totalActualRefundAmount",
  "totalRefundDiff",
  "purchaseRefundProof",
  "financeArrivalProof",
  "remark",
  "status",
  "createTime",
  "操作",
];

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      screenHeight: document.body.clientHeight - 64 - 120 - 100,
      supplierList: [],
      activeStatusTab: "待确认退款信息",
      statusTabs: STATUS_TABS,
      statusCounts: {
        待确认退款信息: 0,
        待退款: 0,
        待财务审核: 0,
        已退款: 0,
        已作废: 0,
      },
      params: {
        supplierId: "",
        refundGroupId: "",
        productName: "",
        beginIndex: 0,
        pageSize: 100,
      },
      purchaseConfirmVisible: false,
      purchaseConfirmRow: null,
      purchaseProofUrls: [],
      purchaseConfirmSaving: false,
      proofUploading: false,
      financeConfirmVisible: false,
      financeConfirmRow: null,
      financeProofUrls: [],
      financeConfirmSaving: false,
      rejectVisible: false,
      rejectRow: null,
      rejectRemark: "",
      rejectSaving: false,
      refundDetailsVisible: false,
      refundDetailsLoading: false,
      refundDetails: [],
      opreateLogVisible: false,
      opreateLogLoading: false,
      operateHistory: [],
    };
  },
  mounted() {
    this.loadSuppliers();
    this.getData();
    this.$nextTick(() => this.calculateHeight());
    this.$eventBus && this.$eventBus.$on && this.$eventBus.$on("resize", this.calculateHeight);
    window.addEventListener("resize", this.calculateHeight);
  },
  beforeDestroy() {
    document.removeEventListener("paste", this.handlePurchaseProofPaste);
    document.removeEventListener("paste", this.handleFinanceProofPaste);
    window.removeEventListener("resize", this.calculateHeight);
    this.$eventBus && this.$eventBus.$off && this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    loadSuppliers() {
      requestModules.fetchSuppliers({ beginIndex: 0, pageSize: 1000 }).then(res => {
        this.supplierList = res.ldata || [];
      });
    },
    calculateHeight() {
      let panel = this.$refs.tablePanel;
      if (!panel) {
        return;
      }
      let tabs = panel.querySelector(".status-tabs");
      let pagination = panel.querySelector(".pagination-box");
      let panelStyle = window.getComputedStyle(panel);
      let paddingTop = parseFloat(panelStyle.paddingTop) || 0;
      let paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
      let available = panel.clientHeight - paddingTop - paddingBottom - (tabs ? tabs.offsetHeight + 12 : 0) - (pagination ? pagination.offsetHeight : 0);
      this.screenHeight = Math.max(available, 200);
    },
    queryBtn() {
      this.params.beginIndex = 0;
      this.currentPage = 1;
      this.getData();
    },
    onStatusTabChange(tab) {
      this.activeStatusTab = tab.name;
      this.params.beginIndex = 0;
      this.currentPage = 1;
      this.getData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.params.beginIndex = (page - 1) * this.params.pageSize;
      this.getData();
    },
    getData() {
      this.loading = true;
      let params = {
        ...this.params,
        statusTab: this.activeStatusTab === "全部" ? "" : this.activeStatusTab,
      };
      refundModules
        .fetchRefunds(params)
        .then(res => {
          this.tableData = res.ldata || [];
          this.total = res.total || 0;
          this.statusCounts = {
            待确认退款信息: 0,
            待退款: 0,
            待财务审核: 0,
            已退款: 0,
            已作废: 0,
            ...(res.mdata && res.mdata.statusCounts ? res.mdata.statusCounts : {}),
          };
        })
        .finally(() => {
          this.loading = false;
          this.$nextTick(() => this.calculateHeight());
        });
    },
    getGroupRowIndex(row) {
      let index = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        if (item._refundRowSpan > 0) {
          index++;
          if (item.refundGroupId === row.refundGroupId) {
            return index;
          }
        }
      }
      return index;
    },
    formatTime(ts) {
      if (!ts) return "-";
      const date = new Date(Number(ts));
      if (Number.isNaN(date.getTime())) return "-";
      const pad = n => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    formatRefundAmount(value) {
      if (value === "" || value === null || value === undefined) {
        return "-";
      }
      return parseFloat(value).toFixed(2);
    },
    formatRefundDiff(value) {
      if (value === "" || value === null || value === undefined) {
        return "-";
      }
      const diff = parseFloat(value) || 0;
      if (diff > 0) {
        return "+" + diff.toFixed(2);
      }
      return diff.toFixed(2);
    },
    getRefundDiffClass(value) {
      if (value === "" || value === null || value === undefined) {
        return "";
      }
      const diff = parseFloat(value) || 0;
      if (diff > 0) return "refund-diff-positive";
      if (diff < 0) return "refund-diff-negative";
      return "";
    },
    spanMethod({ column, row }) {
      let prop = column.property || column.label;
      let shouldMerge =
        MERGE_PROPS.indexOf(prop) >= 0 ||
        column.label === "序号" ||
        column.label === "操作" ||
        column.label === "采购退款证明" ||
        column.label === "财务到账证明" ||
        column.label === "备注" ||
        column.label === "退款状态" ||
        column.label === "供应商" ||
        column.label === "店铺" ||
        column.label === "总应退金额" ||
        column.label === "总实退金额" ||
        column.label === "总差额";
      if (!shouldMerge) {
        return [1, 1];
      }
      if (row._refundRowSpan > 0) {
        return [row._refundRowSpan, 1];
      }
      return [0, 0];
    },
    normalizeProofImageList(value) {
      if (value == null || value === "") {
        return [];
      }
      if (Array.isArray(value)) {
        return value.map(item => String(item || "").trim()).filter(Boolean);
      }
      if (typeof value === "string") {
        let trimmed = value.trim();
        if (!trimmed) {
          return [];
        }
        if (trimmed.charAt(0) === "[") {
          try {
            let parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              return parsed.map(item => String(item || "").trim()).filter(Boolean);
            }
          } catch (error) {
            return [trimmed];
          }
        }
        return [trimmed];
      }
      return [];
    },
    getProofImageList(row, field) {
      return this.normalizeProofImageList(row[field]);
    },
    confirmRefundInfo(row) {
      this.$confirm("确认退款信息无误，流转到「待退款」？", "确认退款信息", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        refundModules
          .updateRefundStatus({
            refundGroupId: row.refundGroupId,
            targetStatus: "待退款",
          })
          .then(res => {
            if (res.result !== 1) {
              this.$message.error(res.message || "操作失败");
              return;
            }
            this.$message.success("已确认退款信息");
            this.getData();
          });
      });
    },
    openPurchaseConfirm(row) {
      this.purchaseConfirmRow = row;
      this.purchaseProofUrls = [...this.getProofImageList(row, "purchaseRefundProof")];
      this.purchaseConfirmVisible = true;
    },
    onPurchaseConfirmDialogOpened() {
      document.addEventListener("paste", this.handlePurchaseProofPaste);
      this.$nextTick(() => {
        if (this.$refs.purchasePastePanel) {
          this.$refs.purchasePastePanel.focus();
        }
      });
    },
    onPurchaseConfirmDialogClosed() {
      document.removeEventListener("paste", this.handlePurchaseProofPaste);
      this.proofUploading = false;
    },
    isProofImageFile(file) {
      if (!file) {
        return false;
      }
      if (file.type && file.type.indexOf("image/") === 0) {
        return true;
      }
      let name = (file.name || "").toLowerCase();
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/.test(name);
    },
    beforeProofImageUpload(file) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请上传图片文件");
        return false;
      }
      return true;
    },
    handlePurchaseProofPaste(event) {
      if (!this.purchaseConfirmVisible || this.proofUploading) {
        return;
      }
      let items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          let file = item.getAsFile();
          if (file) {
            this.uploadProofImageFile(
              file,
              urls => {
                this.purchaseProofUrls = urls;
              },
              this.purchaseProofUrls
            );
          }
          return;
        }
      }
    },
    uploadProofImageFile(file, onSuccess, currentUrls) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "refund");
      this.proofUploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            onSuccess([...(currentUrls || []), res.objData.fileUrl]);
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.proofUploading = false;
        });
    },
    handlePurchaseProofUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        this.purchaseProofUrls.push(res.objData.fileUrl);
        return;
      }
      this.$message.error("上传失败");
    },
    savePurchaseProof() {
      if (!this.purchaseConfirmRow) {
        return;
      }
      if (!this.purchaseProofUrls.length) {
        this.$message.error("请先上传采购已退款证明");
        return;
      }
      this.purchaseConfirmSaving = true;
      refundModules
        .updateRefundAttachment({
          refundGroupId: this.purchaseConfirmRow.refundGroupId,
          purchaseRefundProof: JSON.stringify(this.purchaseProofUrls),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "保存失败");
            return;
          }
          this.$message.success("保存成功");
          this.getData();
        })
        .catch(err => {
          this.$message.error(err.message || "保存失败");
        })
        .finally(() => {
          this.purchaseConfirmSaving = false;
        });
    },
    confirmPurchaseRefunded() {
      if (!this.purchaseConfirmRow) {
        return;
      }
      if (!this.purchaseProofUrls.length) {
        this.$message.error("请先上传采购已退款证明");
        return;
      }
      this.purchaseConfirmSaving = true;
      refundModules
        .updateRefundStatus({
          refundGroupId: this.purchaseConfirmRow.refundGroupId,
          targetStatus: "待财务审核",
          purchaseRefundProof: JSON.stringify(this.purchaseProofUrls),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "操作失败");
            return;
          }
          this.$message.success("已提交财务审核");
          this.purchaseConfirmVisible = false;
          this.getData();
        })
        .finally(() => {
          this.purchaseConfirmSaving = false;
        });
    },
    voidRefund(row) {
      this.$confirm("确认作废该退款单？", "作废", {
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        refundModules
          .updateRefundStatus({
            refundGroupId: row.refundGroupId,
            targetStatus: "已作废",
          })
          .then(res => {
            if (res.result !== 1) {
              this.$message.error(res.message || "操作失败");
              return;
            }
            this.$message.success("已作废");
            this.getData();
          });
      });
    },
    openFinanceConfirm(row) {
      this.financeConfirmRow = row;
      this.financeProofUrls = [...this.getProofImageList(row, "financeArrivalProof")];
      this.financeConfirmVisible = true;
    },
    onFinanceProofDialogOpened() {
      document.addEventListener("paste", this.handleFinanceProofPaste);
      this.$nextTick(() => {
        if (this.$refs.financePastePanel) {
          this.$refs.financePastePanel.focus();
        }
      });
    },
    onFinanceProofDialogClosed() {
      document.removeEventListener("paste", this.handleFinanceProofPaste);
      this.proofUploading = false;
    },
    handleFinanceProofPaste(event) {
      if (!this.financeConfirmVisible || this.proofUploading) {
        return;
      }
      let items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          let file = item.getAsFile();
          if (file) {
            this.uploadProofImageFile(
              file,
              urls => {
                this.financeProofUrls = urls;
              },
              this.financeProofUrls
            );
          }
          return;
        }
      }
    },
    handleFinanceProofUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        this.financeProofUrls.push(res.objData.fileUrl);
        return;
      }
      this.$message.error("上传失败");
    },
    saveFinanceProof() {
      if (!this.financeConfirmRow) {
        return;
      }
      if (!this.financeProofUrls.length) {
        this.$message.error("请先上传财务到账证明");
        return;
      }
      this.financeConfirmSaving = true;
      refundModules
        .updateRefundAttachment({
          refundGroupId: this.financeConfirmRow.refundGroupId,
          financeArrivalProof: JSON.stringify(this.financeProofUrls),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "保存失败");
            return;
          }
          this.$message.success("保存成功");
          this.getData();
        })
        .catch(err => {
          this.$message.error(err.message || "保存失败");
        })
        .finally(() => {
          this.financeConfirmSaving = false;
        });
    },
    confirmFinanceRefunded() {
      if (!this.financeConfirmRow) {
        return;
      }
      if (!this.financeProofUrls.length) {
        this.$message.error("请先上传财务到账证明");
        return;
      }
      this.financeConfirmSaving = true;
      refundModules
        .updateRefundStatus({
          refundGroupId: this.financeConfirmRow.refundGroupId,
          targetStatus: "已退款",
          financeArrivalProof: JSON.stringify(this.financeProofUrls),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "操作失败");
            return;
          }
          this.$message.success("已确认到账");
          this.financeConfirmVisible = false;
          this.getData();
        })
        .finally(() => {
          this.financeConfirmSaving = false;
        });
    },
    openRejectDialog(row) {
      this.rejectRow = row;
      this.rejectRemark = "";
      this.rejectVisible = true;
    },
    confirmReject() {
      if (!this.rejectRemark || !this.rejectRemark.trim()) {
        this.$message.error("请填写打回原因");
        return;
      }
      this.rejectSaving = true;
      refundModules
        .updateRefundStatus({
          refundGroupId: this.rejectRow.refundGroupId,
          targetStatus: "待退款",
          rejectRemark: this.rejectRemark.trim(),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "打回失败");
            return;
          }
          this.$message.success("已打回至待退款");
          this.rejectVisible = false;
          this.getData();
        })
        .finally(() => {
          this.rejectSaving = false;
        });
    },
    openRefundDetails(row) {
      this.refundDetailsVisible = true;
      this.refundDetailsLoading = true;
      this.refundDetails = [];
      refundModules
        .fetchRefundPurchaseRecords({ refundGroupId: row.refundGroupId })
        .then(res => {
          this.refundDetails = res.ldata || [];
          if (!this.refundDetails.length) {
            this.$message.info("暂无退款明细");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取退款明细失败");
        })
        .finally(() => {
          this.refundDetailsLoading = false;
        });
    },
    getRefundDetailSummaries({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "refundQuantity" || column.property === "planPurchase") {
          sums[index] = (data || []).reduce((sum, row) => sum + (Number(row[column.property]) || 0), 0);
          return;
        }
        if (["refundAmount", "expectedRefundAmount", "actualRefundAmount"].includes(column.property)) {
          const hasValue = (data || []).some(
            row => row[column.property] !== "" && row[column.property] !== null && row[column.property] !== undefined
          );
          sums[index] = hasValue
            ? this.formatRefundAmount((data || []).reduce((sum, row) => sum + (parseFloat(row[column.property]) || 0), 0))
            : "-";
          return;
        }
        if (column.property === "refundDiff") {
          const hasValue = (data || []).some(
            row => row.refundDiff !== "" && row.refundDiff !== null && row.refundDiff !== undefined
          );
          if (!hasValue) {
            sums[index] = "-";
            return;
          }
          const totalDiff = (data || []).reduce((sum, row) => sum + (parseFloat(row.refundDiff) || 0), 0);
          sums[index] = this.formatRefundDiff(totalDiff);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    showOpreateLog(row) {
      if (!row || !row.refundGroupId) {
        this.$message.warning("缺少退款单号");
        return;
      }
      this.operateHistory = [];
      this.opreateLogVisible = true;
      this.opreateLogLoading = true;
      requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId: row.refundGroupId,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取操作记录失败");
            return;
          }
          this.operateHistory = res.ldata || [];
          if (!this.operateHistory.length) {
            this.$message.info("暂无操作记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        })
        .finally(() => {
          this.opreateLogLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#RefundMgmt {
  .reject-remark {
    margin-top: 4px;
    color: #e6a23c;
    font-size: 12px;
  }

  .action-btn.success,
  .action-cell .success {
    color: #67c23a;
  }

  .action-cell .warning {
    color: #e6a23c;
  }

  .action-cell .danger {
    color: #f56c6c;
  }

  .proof-thumb-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
    padding: 2px 0;
  }

  .proof-thumb {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    vertical-align: middle;
  }

  .proof-empty {
    color: #c0c4cc;
  }

  .refund-diff-positive {
    color: #67c23a;
  }

  .refund-diff-negative {
    color: #f56c6c;
  }

  .finance-confirm-tip {
    margin-bottom: 12px;
    color: #606266;
    font-size: 13px;
  }
}

.refund-proof-dialog,
#RefundMgmt {
  .proof-upload-panel {
    outline: none;
  }

  .proof-upload-panel:focus {
    box-shadow: none;
  }

  .proof-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .proof-upload-item {
    position: relative;
    width: 96px;
    height: 96px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
  }

  .proof-upload-image {
    width: 100%;
    height: 100%;
  }

  .proof-upload-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    color: #f56c6c;
    font-size: 18px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
  }

  .proof-upload-add .el-upload {
    width: 96px;
    height: 96px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
  }

  .proof-upload-add .el-upload:hover {
    border-color: #409eff;
  }

  .proof-upload-trigger {
    width: 96px;
    height: 96px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #8c939d;
  }

  .proof-upload-text {
    margin-top: 6px;
    font-size: 12px;
  }

  .proof-upload-tip {
    margin-top: 12px;
    color: #909399;
    font-size: 12px;
  }
}
</style>
